import React, { useEffect, useState } from 'react';
import './Careers.css';
import { useNavigate } from 'react-router-dom';

const Careers = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  

  useEffect(() => {
    const storedJobs = JSON.parse(localStorage.getItem('jobs') || '[]');
    setJobs(storedJobs);
    setLoading(false);
  }, []);

  useEffect(() => {
    fetch("/api/jobs")
      .then((res) => res.json())
      .then((data) => {
        setJobs(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fetch jobs error:", err);
        setLoading(false);
      });
  }, []);

  const handleApply = (jobTitle) => {
    navigate('/jobap', { state: { jobTitle } });
  };

  const handleSubmitResume = () => {
    // Add your resume submission logic here
    console.log('Submit resume clicked');
  };

  if (loading) {
    return (
      <div className="careers-page">
        <div className="loading-spinner">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="careers-page">
      {/* Header Section */}
         <div
  className="jumbotron jumbotron-fluid page-header position-relative overlay-bottom"
  style={{ marginBottom: '90px', }}
>
  <div className="container text-center py-5" style={{ marginTop: "-80px" }}>
    <h1 className="text-white display-1">Careers</h1>
    <div className="d-inline-flex text-white mb-5">
      <p className="m-0 text-uppercase">
        <a className="text-white" href="">Home</a>
      </p>
      <i className="fa fa-angle-double-right pt-1 px-3"></i>
      <p className="m-0 text-uppercase">Careers</p>
    </div>

   
  </div>
  </div>
      <div className="careers-header">
        <div className="careers-header-content">
          <h1 className="careers-title">Join Our Team</h1>
          <p className="careers-subtitle">
            Discover exciting career opportunities and be part of our innovative journey
          </p>
          <div className="careers-stats">
            <div className="stat-item">
              <svg className="stat-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2V6z" />
              </svg>
              {jobs.length} Open Positions
            </div>
            <div className="stat-item">
              <svg className="stat-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              Multiple Locations
            </div>
          </div>
        </div>
      </div>

      {/* Jobs Section */}
      <div className="careers-container">
        {jobs.length === 0 ? (
          <div className="no-jobs">
            <div className="no-jobs-icon">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2V6z" />
              </svg>
            </div>
            <h3 className="no-jobs-title">No open positions</h3>
            <p className="no-jobs-text">Check back soon for new opportunities!</p>
          </div>
        ) : (
          <div className="careers-grid">
            {jobs.map((job, index) => (
              <div className="career-card" key={index}>
                {/* Job Header */}
                <div className="job-header">
                  <div className="job-title-section">
                    <h3 className="job-title">{job.title}</h3>
                    <p className="job-company">{job.name}</p>
                  </div>
                  <div className="job-icon">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2V6z" />
                    </svg>
                  </div>
                </div>

                {/* Job Details */}
                <div className="job-details">
                  <div className="detail-item">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <span className="detail-value">{job.location}</span>
                  </div>
                  <div className="detail-item">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span className="detail-value">{job.type}</span>
                  </div>
                  <div className="detail-item">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                    </svg>
                    <span className="detail-value">₹{job.salary}</span>
                  </div>
                  <div className="detail-item">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                    </svg>
                    <span className="detail-value">{job.field}</span>
                  </div>
                </div>

                {/* Description */}
                <div className="job-description">
                  <p>{job.description}</p>
                </div>

                {/* Qualifications */}
                <div className="qualifications-section">
                  <div className="section-header">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                    </svg>
                    <span className="section-title">Required Qualifications</span>
                  </div>
                  <p className="qualifications-text">{job.qualifications}</p>
                </div>

                {/* Skills */}
                <div className="skills-section">
                  <div className="skills-header">
                    <div className="skills-icon"></div>
                    <span className="section-title">Key Skills</span>
                  </div>
                  <div className="skills-list">
                    {job.skills.split(',').map((skill, skillIndex) => (
                      <span key={skillIndex} className="skill-tag">
                        {skill.trim()}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Apply Button */}
                <button
                  className="apply-btn"
                  onClick={() => handleApply(job.title)}
                >
                  <span>Apply Now</span>
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Footer CTA */}
      {/* <div className="footer-cta">
        <div className="footer-cta-content">
          <h2 className="footer-title">Don't see the perfect role?</h2>
          <p className="footer-text">
            Send us your resume and we'll keep you in mind for future opportunities
          </p>
          <button className="footer-btn" onClick={handleSubmitResume}>
            Submit Your Resume
          </button>
        </div>
      </div> */}
    </div>
  );
};

export default Careers;